export default __webpack_public_path__ + "6ebaf18ea756c13c52c88fe0dc5328f4.svg";